import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { REVIEW_SUMMARY_DATA_HOOKS } from './dataHooks';
import {
  ProgressBarDriver,
  progressBarDriverFactory,
} from '../ProgressBar/ProgressBar.driver';

export interface ReviewSummaryDriver extends BaseUniDriver {
  getNumberOfItems(): Promise<number>;
  getItemAt(index: number): ProgressBarDriver;
}

export const reviewSummaryDriverFactory = (
  base: UniDriver,
): ReviewSummaryDriver => {
  return {
    ...baseUniDriverFactory(base),
    getNumberOfItems: () =>
      base.$$(`[data-hook="${REVIEW_SUMMARY_DATA_HOOKS.Item}"]`).count(),
    getItemAt: (index) =>
      progressBarDriverFactory(
        base.$$(`[data-hook="${REVIEW_SUMMARY_DATA_HOOKS.Item}"]`).get(index),
      ),
  };
};
